var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.isLoading,
      expression: "isLoading"
    }],
    staticClass: "home"
  }, [_c('Header', {
    attrs: {
      "isClassifyBtn": true
    }
  }), _c('div', {
    staticClass: "theme-content"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_vm.dataInfo.topicImage ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: _vm.dataInfo.topicImage.cdnFilePathPc,
      expression: "dataInfo.topicImage.cdnFilePathPc"
    }]
  }) : _vm._e(), _vm._l(_vm.dataInfo.list, function (item, index) {
    return _c('a', {
      key: index,
      style: {
        top: item.top + '%',
        left: item.left + '%',
        width: item.width + '%',
        height: item.height + '%'
      },
      on: {
        "click": function click($event) {
          return _vm.selectHref(item);
        }
      }
    });
  })], 2)]), _c('BackTop'), _c('Footer')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };